import { ListIllustration } from "vega-illustrations";

import { CoreTable } from "@vega-core/components/Table/CoreTable/CoreTable";
import { m } from "@vega-core/paraglide/messages";

import { type HistoryRow } from "../../utils/formatFinancialReturns";

import { useReportingHistoryColumns } from "./hooks/useReportingHistoryColumns";

type ReportingHistoryTableProps = {
  borderless?: boolean;
  history: HistoryRow[];
  isLoading: boolean;
  onEdit?: (snapshot: HistoryRow) => void;
};

export function ReportingHistoryTable({
  borderless,
  history,
  isLoading,
  onEdit,
}: ReportingHistoryTableProps) {
  const columns = useReportingHistoryColumns(onEdit);

  return (
    <CoreTable
      borderless={borderless}
      columns={columns}
      data={history}
      dataTestId="reporting-history-table"
      emptyState={{
        title: m.coInvestments_report_reportingHistory_noData(),
        illustration: <ListIllustration />,
      }}
      isLoading={isLoading}
      noSorting={false}
      wrapperClassName="overflow-x-auto"
    />
  );
}
